import * as React from 'react';
import * as ReactDOM from 'react-dom';
if (process.env.NODE_ENV !== 'production') {
    import('@axe-core/react').then((axe) => {
        var _a, _b;
        const react = (_a = React.default) !== null && _a !== void 0 ? _a : React;
        const reactDOM = (_b = ReactDOM.default) !== null && _b !== void 0 ? _b : ReactDOM;
        axe.default(react, reactDOM, 1000);
    });
}
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
ReactDOM.render(<App config={config}/>, target);
